import { create } from 'zustand';
import { AlertColor } from '@mui/material';

import { NotificationMessage } from '@/types';

type NotificationStore = {
  notificationMessages: NotificationMessage[];
  notificationsAllowed: boolean;
  showNotification: (severity: AlertColor, message: string, onClose?: () => void, timeoutSec?: number) => void;
  shift: () => void;
  clearAllNotifications: () => void;
  setNotificationsAllowed: (allowed: boolean) => void;
};

const useNotificationStore = create<NotificationStore>((set) => ({
  notificationMessages: [],
  notificationsAllowed: true,
  showNotification: (severity: AlertColor, message: string, onClose?: () => void, timeoutSec?: number) =>
    set((state) => {
      if (!state.notificationsAllowed) return {}; // ez a notification elveszik

      const newNotificationMessage = {
        severity,
        message,
        onClose,
        timeoutSec,
      } satisfies NotificationMessage;

      const duplicateIndex = state.notificationMessages.findIndex((value) => value.message === message);
      if (duplicateIndex !== -1) {
        if (onClose) {
          const duplicate = state.notificationMessages[duplicateIndex];
          const notificationMessages = [...state.notificationMessages];
          notificationMessages[duplicateIndex] = { ...duplicate, onClose };
          return { notificationMessages };
        }
        return {};
      }

      return {
        notificationMessages: [...state.notificationMessages, newNotificationMessage],
      };
    }),
  shift: () =>
    set((state) => {
      return {
        notificationMessages: state.notificationMessages.slice(1),
      };
    }),
  clearAllNotifications: () => set({ notificationMessages: [] }),
  setNotificationsAllowed: (allowed: boolean) =>
    set((state) => {
      return {
        notificationMessages: allowed
          ? state.notificationMessages
          : state.notificationMessages.filter((message) => message.severity !== 'error'),
        notificationsAllowed: allowed,
      };
    }),
}));

export { useNotificationStore };
